module.exports = __webpack_public_path__ + "img/blue_chair.9b1bb77a.svg";